import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import netBg from '../../Media/net.png';

const viewportConfig = { 
  threshold: 0.1,
  triggerOnce: false,
  rootMargin: "-50px 0px"
};

const containerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut",
      staggerChildren: 0.15,
      when: "beforeChildren"
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

const AboutUsTitle = () => {
  const [ref, inView] = useInView(viewportConfig);
  const controls = useAnimation();

  React.useEffect(() => {
    controls.start(inView ? "visible" : "hidden");
  }, [controls, inView]);

  return (
    <Box
      ref={ref}
      component={motion.div}
      variants={containerVariants}
      initial="hidden"
      animate={controls}
      sx={{ 
        bgcolor:'#F7F9FC',
        width: '100%',
        position: 'relative',
        height: '400px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {/* Flipped Net Pattern Background */}
      <Box
        component="img"
        src={netBg}
        alt="net"
        sx={{
          position: 'absolute',
          width: { xs: 'auto', md: 'auto', lg: '160%' },
          height: '100%',
          objectFit: 'fill',
          opacity: 0.6,
          mixBlendMode: 'revert',
          transform: 'scaleY(-1)',
          top: 0,
          left: 0
        }}
      />

      {/* Content */}
      <Box
        component={motion.div}
        variants={itemVariants}
        sx={{
          position: 'relative',
          zIndex: 1,
          textAlign: 'center'
        }}
      >
        <Typography 
          variant="h2" 
          sx={{ 
            color: '#1A1A1A',
            fontWeight: 'bold',
            fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem' },
            mb: 2,
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              left: 0,
              bottom: -10,
              width: '100%',
              height: '4px',
              background: 'linear-gradient(to right, transparent, #64B5F6, transparent)',
              borderRadius: '2px'
            }
          }}
        >
          About US
        </Typography>
      </Box>
    </Box>
  );
};

export default AboutUsTitle; 